import React from 'react';
import ReactDOM from 'react-dom/client';
import thunkMiddleware from 'redux-thunk'
import persistState from 'redux-localstorage'

import { BrowserRouter as Router } from 'react-router-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import rootReducer from './redux'

import App from './Containers/App';
import * as serviceWorker from './serviceWorker'
import './index.css'
import axios from 'axios'

// Every API call carries the admin's token. Some screens (the navbar's
// polling, the order board's courier calls, Facturi) were written without
// it, and the API is starting to require it there too. Calls that set their
// own Authorization header keep it.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  const url = config.url || '';
  const isApi = url.startsWith('https://api.appetito.ro/') || url.startsWith('http://localhost:8080/');
  if (token && isApi && !(config.headers && config.headers.Authorization)) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
  }
  return config;
});


// This app's layout is fixed-width/desktop-oriented, not responsive — the
// static `width=1280` viewport meta (public/index.html) makes mobile
// browsers shrink the whole page to fit on initial load, but on some mobile
// browsers a *fixed* viewport width doesn't get its zoom recomputed on
// rotation, so landscape can come back at 1:1 instead of staying fitted.
// Recalculating initial-scale ourselves on load/rotation/resize fixes that.
// window.screen.width (not window.innerWidth, which reports the *already
// zoomed* CSS viewport, not the physical screen) tracks the device's
// current-orientation width directly.
const DESKTOP_LAYOUT_WIDTH = 1280;
// Portrait wants a closer-in view than the fitted 1280-wide default —
// halving the virtual width here doubles the resulting scale (scale =
// screen.width / layoutWidth), i.e. "zoom in twice as much," only in
// portrait. Landscape keeps the normal fit.
const PORTRAIT_LAYOUT_WIDTH = DESKTOP_LAYOUT_WIDTH / 2;

const fitViewportToScreen = () => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) {
        return;
    }
    const isPortrait = window.screen.width < window.screen.height;
    const layoutWidth = isPortrait ? PORTRAIT_LAYOUT_WIDTH : DESKTOP_LAYOUT_WIDTH;
    const scale = Math.min(1, window.screen.width / layoutWidth);
    meta.setAttribute('content', `width=${layoutWidth}, initial-scale=${scale}`);
};

fitViewportToScreen();
window.addEventListener('resize', fitViewportToScreen);
window.addEventListener('orientationchange', fitViewportToScreen);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(
            thunkMiddleware
        ),
        persistState(/*paths, config*/)
    )
)

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement)

root.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
